const S = {
  isPrimaryFilter: !1,
  isSecondaryFilter: !1,
  isSecondaryMandatory: !0,
  isSequential: !1,
  isPrimaryZeroBase: !1
}, x = (e, i) => i.reduce(
  (r, s) => ({
    ...r,
    [s]: {
      ...S,
      ...e.dimensionFlags?.[s] || {}
    }
  }),
  {}
), k = (e, i) => ({
  dimensionRestrictions: {},
  mandatoryFilterDefaults: {},
  singlePrimaryFilterDefaults: {},
  ...e,
  dimensionFlags: x(e, i)
}), U = (e, i, r) => {
  const s = {
    ...i.mandatoryFilterDefaults,
    ...e.filters
  };
  let n = e.primary || "", t = e.secondary || "";
  const o = e.unitsDimension, l = Array.isArray(e.primaryFilter) ? [...e.primaryFilter] : [], a = Array.isArray(e.secondaryFilter) ? [...e.secondaryFilter] : [], u = e.isLineChart || !1, f = e.isDescriptionOpen || !1, y = e.isExplanationOpen || !1, m = e.isTableMode || !1, p = h(i, r, o);
  p.length && !p.includes(e.primary || "") && (e.secondary && p.includes(e.secondary) ? n = e.secondary : n = p[0]);
  const d = D(
    i,
    r,
    n,
    o
  );
  t ? d.includes(t) || (t = d?.[0] || "") : d.length && (t = d[0]);
  for (const c in s)
    c === n || c === t ? delete s[c] : typeof i.mandatoryFilterDefaults?.[c] < "u" && !s[c] && (s[c] = i.mandatoryFilterDefaults[c]);
  if (i.dimensionFlags[n].isPrimaryFilter) {
    const c = i.singlePrimaryFilterDefaults[n];
    c && l.length !== 1 && (l.splice(0, l.length), l[0] = c);
  }
  return {
    primary: n,
    secondary: t,
    filters: s,
    primaryFilter: l,
    secondaryFilter: a,
    isDescriptionOpen: f,
    isExplanationOpen: y,
    isLineChart: u,
    unitsDimension: o,
    isTableMode: m
  };
}, h = (e, i, r) => i.filter(
  (s) => s !== r && (!e.dimensionRestrictions[s] || e.dimensionRestrictions[s].primary)
), D = (e, i, r, s) => {
  const n = i.filter(
    (t) => t !== s && t !== r && (!e.dimensionRestrictions[t] || e.dimensionRestrictions[t].secondary)
  );
  return e.dimensionFlags[r]?.isSecondaryMandatory || n.unshift(""), n;
}, C = (e, i, r, s) => {
  const n = h(i, r, s);
  return { value: n.includes(e) && e || n?.[0] || "", choices: n, property: "primary" };
}, L = (e, i, r, s, n) => {
  const t = D(i, r, s, n);
  return { value: t.includes(e) ? e : t[0] || "", choices: t, property: "secondary" };
}, M = (e, i, r, s, n, t, o) => {
  const l = { ...r.map((a) => a.name).reduce(
    (a, u) => ({
      ...a,
      [u]: i.mandatoryFilterDefaults[u] || ""
    }),
    {}
  ), ...e };
  for (const a in l)
    (a === s || a === n) && delete l[a];
  return Object.keys(l).filter((a) => T(a, i)).map((a) => {
    const u = g(a, r);
    let f;
    if (o && t && a === o && typeof t.units == "object" && "fieldUnits" in t.units) {
      const p = t.units.fieldUnits;
      f = u.map(
        (d) => j(p[d], t)
      );
    }
    const y = i.mandatoryFilterDefaults[a] || a === o ? [...u] : ["", ...u];
    let m = l[a];
    return y.includes(m) || (m = y[0] || ""), f ? {
      displayChoices: f,
      name: a,
      choices: y,
      property: "filters",
      value: m
    } : {
      name: a,
      choices: y,
      property: "filters",
      value: m
    };
  });
}, F = (e, i, r, s, n) => {
  const t = n === "secondaryFilter" ? "isSecondaryFilter" : "isPrimaryFilter";
  if (i.dimensionFlags[e]?.[t]) {
    const o = g(e, r);
    return n === "primaryFilter" && i.singlePrimaryFilterDefaults[e] ? s && s.length === 1 && o.includes(s[0]) ? {
      value: s,
      choices: o,
      property: n,
      max: 1
    } : {
      value: [i.singlePrimaryFilterDefaults[e]],
      choices: o,
      property: n,
      max: 1
    } : s && s.length && s.every((l) => o.includes(l)) ? {
      value: [...s],
      choices: o,
      property: n
    } : {
      value: [...o],
      choices: o,
      property: n
    };
  }
  return { value: [], choices: [], property: n };
}, R = (e, i, r) => {
  const s = "isLineChart";
  return i.dimensionFlags?.[e]?.isSequential ? {
    value: r,
    choices: [!1, !0],
    property: s
  } : {
    value: !1,
    choices: [!1],
    property: s
  };
}, v = (e, i) => ({
  value: e[i],
  choices: [!1, !0],
  property: i
}), q = (e, i, r, s) => {
  const n = r.map((A) => A.name), { unitsDimension: t } = e, o = {
    ...i.mandatoryFilterDefaults,
    ...e.filters
  }, l = C(
    e.primary,
    i,
    n,
    e.unitsDimension
  ), a = L(
    e.secondary,
    i,
    n,
    l.value,
    e.unitsDimension
  ), u = M(
    o,
    i,
    r,
    l.value,
    a.value,
    s,
    t
  ), f = l.value === e.primary ? e.primaryFilter : l.value === e.secondary ? e.secondaryFilter : [], y = a.value === e.secondary ? e.secondaryFilter : a.value === e.primary ? e.primaryFilter : [], m = F(
    l.value,
    i,
    r,
    f,
    "primaryFilter"
  ), p = F(
    a.value,
    i,
    r,
    y,
    "secondaryFilter"
  ), d = v(e, "isDescriptionOpen"), c = v(e, "isExplanationOpen"), b = l.value === e.primary ? e.isLineChart : !0, P = R(
    l.value,
    i,
    b
  ), O = {
    value: e.isTableMode,
    property: "isTableMode",
    choices: [!0, !1]
  };
  return {
    primary: l,
    secondary: a,
    filters: u,
    primaryFilter: m,
    secondaryFilter: p,
    isDescriptionOpen: d,
    isExplanationOpen: c,
    isLineChart: P,
    unitsDimension: t,
    isTableMode: O
  };
}, B = (e) => ({
  primary: e.primary.value,
  secondary: e.secondary.value,
  filters: e.filters.reduce(
    (i, r) => ({
      ...i,
      [r.name]: r.value
    }),
    {}
  ),
  primaryFilter: e.primaryFilter.value,
  secondaryFilter: e.secondaryFilter.value,
  isDescriptionOpen: e.isDescriptionOpen.value,
  isExplanationOpen: e.isExplanationOpen.value,
  isLineChart: e.isLineChart.value,
  unitsDimension: e.unitsDimension,
  isTableMode: e.isTableMode.value
}), g = (e, i) => i.find((r) => r.name === e)?.fieldOptions.map((r) => r.name) || [], T = (e, i) => e ? !i.dimensionRestrictions[e] || i.dimensionRestrictions[e].filter : !1, H = {
  Amount: "Antall",
  "Per 1000": "Pr 1000",
  Percent: "%",
  Proportion: "Andel"
}, E = {
  Amount: "Antall",
  "Per 1000": "Pr. 1000",
  Percent: "Prosent",
  Proportion: "Andel"
}, N = (e, i) => Object.keys(i).map((r) => ({ fieldName: r, units: i[r] })).filter((r) => r.units === e)[0]?.fieldName, j = (e, i) => {
  const r = i.units;
  let s;
  return typeof r == "string" ? s = { [E[e]]: e } : s = r.fieldUnits, i.names?.[e] || N(e, s) || e;
}, I = (e) => e.split("").reduce((i, r) => (i = (i << 5) - i + r.charCodeAt(0), i & i), 0), Z = (e) => (i) => {
  if (typeof i != "number")
    return "..";
  const r = e && i % 1 !== 0 ? 1 : 0;
  try {
    return i.toLocaleString(["nb", "nn"], {
      minimumFractionDigits: r,
      maximumFractionDigits: r
    });
  } catch {
    return i.toFixed(r);
  }
}, G = (e) => typeof e == "number" && Number.isFinite(e);
export {
  Z as createNumberFormatter,
  k as createRules,
  q as createStatisticsInput,
  U as createStatisticsSettings,
  G as isNumber,
  I as makeHash,
  B as toSettings,
  H as unitLabels,
  E as unitTranslate
};
//# sourceMappingURL=index.es82.js.map
